import { render, staticRenderFns } from "./msgPreview.vue?vue&type=template&id=7ceb9258&scoped=true"
import script from "./msgPreview.vue?vue&type=script&lang=js"
export * from "./msgPreview.vue?vue&type=script&lang=js"
import style0 from "./msgPreview.vue?vue&type=style&index=0&id=7ceb9258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceb9258",
  null
  
)

export default component.exports